module.exports = __webpack_public_path__ + "static/media/defaultBcg.0819a816.jpeg";